var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteEditorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.375H1.81875C1.93491 5.60146 2.21112 4.86066 2.62974 4.1999C3.04837 3.53914 3.6002 2.97295 4.25 2.5375L5.36875 1.7875L4.68125 0.75L3.5625 1.5C2.6208 2.12755 1.84857 2.97785 1.31433 3.97545C0.780098 4.97305 0.500379 6.08711 0.5 7.21875V11.375C0.5 11.7065 0.631696 12.0245 0.866116 12.2589C1.10054 12.4933 1.41848 12.625 1.75 12.625H5.5C5.83152 12.625 6.14946 12.4933 6.38388 12.2589C6.6183 12.0245 6.75 11.7065 6.75 11.375V7.625C6.75 7.29348 6.6183 6.97554 6.38388 6.74112C6.14946 6.5067 5.83152 6.375 5.5 6.375ZM14.25 6.375H10.5688C10.6849 5.60146 10.9611 4.86066 11.3797 4.1999C11.7984 3.53914 12.3502 2.97295 13 2.5375L14.1188 1.7875L13.4375 0.75L12.3125 1.5C11.3708 2.12755 10.5986 2.97785 10.0643 3.97545C9.5301 4.97305 9.25038 6.08711 9.25 7.21875V11.375C9.25 11.7065 9.3817 12.0245 9.61612 12.2589C9.85054 12.4933 10.1685 12.625 10.5 12.625H14.25C14.5815 12.625 14.8995 12.4933 15.1339 12.2589C15.3683 12.0245 15.5 11.7065 15.5 11.375V7.625C15.5 7.29348 15.3683 6.97554 15.1339 6.74112C14.8995 6.5067 14.5815 6.375 14.25 6.375Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteEditorIcon);
export default __webpack_public_path__ + "static/media/quote-editor-icon.868f4fa2a650e76eea597cb1226cd904.svg";
export { ForwardRef as ReactComponent };